export enum DepositPaymentMode {
  Charge = 'charge',
  PreAuth = 'preAuth',
}
